import { axiosInstanceV2 } from "@src/shared/api";
import { PAYMENTS_API_URL } from "../constants";
import { tariffsResponseDto } from "../interfaces/tariffsResponseDto";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

export const getTariffs = () => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstanceV2.get<tariffsResponseDto>(
    PAYMENTS_API_URL.getTariffs(),
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );
};
